import React, { useState, useEffect } from "react";
import EditIcon from "@mui/icons-material/Edit";
import { useLazyVersionListQuery, useVersionAddMutation } from "../redux/api/api";
import apiRequest from "../redux/api/apiRequest";
import { toast } from "react-toastify";
 



const InAppControl = () => {

    const [editAndroid, setEditAndroid] = useState(false);
    const [editIos, setEditIos] = useState(false);

    const [androidVersion, setAndroidVersion] = useState("");
    const [iosVersion, setIosVersion] = useState("");

    const [androidChanged, setAndroidChanged] = useState(false);
    const [iosChanged, setIosChanged] = useState(false);

    const [versionAdd] = useVersionAddMutation();
    const [getVersionList] = useLazyVersionListQuery();

    const [androidLoading, setAndroidLoading] = useState(false);
    const [iosLoading, setIosLoading] = useState(false);

    //    const handlesubmit=()=>{
    //     console.log("android",androidVersion)
    //     console.log("ios",iosVersion)
    //     setEditAndroid(false)
    //     setEditIos(false)
    //    }

    useEffect(() => {
        loadVersions();
    }, [])

    const loadVersions = async () => {
        const res = await apiRequest(getVersionList);
        console.log(res)

        if (res?.data?.length) {

            const android = res.data.find(item => item.type === 2);
            const ios = res.data.find(item => item.type === 1);

            if (android) setAndroidVersion(android.setting_value);
            if (ios) setIosVersion(ios.setting_value);
        }
    };

    const handleAndroidSubmit = async () => {
        if (!androidVersion.trim()) {
            toast.error("Android version cannot be empty");
            return;
        }

        setAndroidLoading(true);
        const payload = {
            type: 2,
            setting_value: androidVersion
        };

        const res = await apiRequest(versionAdd, payload);

        setAndroidLoading(false);

        if (!res.error) {
            console.log("Android Version Updated");
            toast.success("Android Version Updated Successfully");


            setEditAndroid(false);
            setAndroidChanged(false);
            // loadVersions();
        };
    }

    const handleIosSubmit = async () => {
        if (!iosVersion.trim()) {
            toast.error("IOS version cannot be empty");
            return;
        }
        setIosLoading(true);
        const payload = {
            type: 1,
            setting_value: iosVersion
        };
        const res = await apiRequest(versionAdd, payload);
        setIosLoading(false);

        if (!res.error) {
            console.log("IOS Version Updated");
            toast.success("IOS Version Updated Successfully");

            setEditIos(false);
            setIosChanged(false);

            // loadVersions();
        }
    };


    return (

        <div className="container-fluid p-3 p-md-4">
            <h3 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 primary ">
                Settings
            </h3>
            <h4 className="f2 fs-sm-14 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 mb-4">
                In-app updates
            </h4>
            <div className="row mb-4">
                <div className="col-12 col-md-6">
                    <h5 className="f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-18 fs-xxl-20">
                        User Android
                    </h5>
                    <p className="text-muted fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14">
                        Current version
                    </p>
                    <div className="d-flex flex-column flex-md-row align-items-md-center gap-2">
                        <input
                            type="text"
                            value={androidVersion}
                            disabled={!editAndroid}
                            onChange={(e) => {
                                const value = e.target.value;

                                if (/^[0-9.]*$/.test(value)) {
                                    setAndroidVersion(value)
                                    setAndroidChanged(true)
                                }

                            }}
                            className="form-control w-100 "
                            style={{
                                background: editAndroid ? "#fff" : "#f3f3f3",
                                maxWidth: "70%",
                            }} />

                        {!editAndroid && (
                            <button
                                className="btn"
                                onClick={() => setEditAndroid(true)}
                                style={{
                                    background: "#e9e6ff",
                                    borderRadius: "50%",
                                    padding: "8px",
                                    minWidth: "40px"
                                }} >
                                <EditIcon fontSize="small" />
                            </button>
                        )}
                        {editAndroid && androidChanged && (
                            <button
                                className="btn btn-primary"
                                onClick={handleAndroidSubmit}
                                disabled={!androidVersion.trim() || androidLoading}

                            >
                                {androidLoading ? "Updating..." : "Submit"}
                            </button>
                        )}

                    </div>
                </div>

                <div className="col-12 col-md-6">
                    <h5 className="f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-18 fs-xxl-20">
                        User IOS
                    </h5>
                    <p className="text-muted fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14">
                        Current version
                    </p>
                    <div className="d-flex flex-column flex-md-row align-items-md-center gap-2">
                        <input
                            type="text"
                            value={iosVersion}
                            disabled={!editIos}
                            onChange={(e) => {
                                const value = e.target.value;

                                if (/^[0-9.]*$/.test(value)) {
                                    setIosVersion(value)
                                    setIosChanged(true)
                                }
                            }}

                            className="form-control w-100 "
                            style={{
                                background: editIos ? "#fff" : "#f3f3f3",
                                maxWidth: "70%",

                            }}
                        />

                        {!editIos && (
                            <button
                                className="btn"
                                onClick={() => setEditIos(true)}
                                style={{ background: "#e9e6ff", borderRadius: "50%" }}
                            >
                                <EditIcon fontSize="small" />
                            </button>
                        )}

                        {editIos && iosChanged && (
                            <button
                                className="btn btn-primary"
                                onClick={handleIosSubmit}
                                disabled={!iosVersion.trim() || iosLoading}
                            >
                                {iosLoading ? "Updating..." : "Submit"}
                            </button>
                        )}

                    </div>
                </div>

                {/* <div className="d-flex justify-content-center justify-content-md-end mt-4">
                    <button
                        // className="btn text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18"
                        className="btn"
                        onClick={handlesubmit}
                        style={{
                            background: "#45b1f0",
                            color: "#fff",
                            padding: "6px 20px",
                            borderRadius: "6px",
                            border: "none"
                        }}> Submit </button>
                </div> */}
            </div>
        </div>

    );
};

export default InAppControl;